import {useEnumIntl} from "../../../intl/helpers/useEnumIntl";
import {defineMessages} from "react-intl";

// *** DO NOT CHANGE WITHOUT BACKEND DEVELOPERS AGREEMENT ***
export enum PlaneStatus {
  UPLOAD_DOCUMENTS = 1,
  PENDING_APPROVAL = 2,
  APPROVED = 3,
}

const PlaneStatusNameMessages = defineMessages({
  uploadDocuments: {
    id: "statuses.planeStatus.uploadDocuments",
    defaultMessage: "Upload the documents",
  },
  pendingApproval: {
    id: "statuses.planeStatus.pendingApproval",
    defaultMessage: "Documents approval pending",
  },
  approved: {
    id: "statuses.planeStatus.approved",
    defaultMessage: "Documents checked",
  },
})

const PlaneStatusNameMessagesForOperator = defineMessages({
  declined: {
    id: "statuses.planeStatus.operator.declined",
    defaultMessage: "Отклонен",
  },
  pendingReview: {
    id: "statuses.planeStatus.operator.pendingReview",
    defaultMessage: "На рассмотрении",
  },
  approved: {
    id: "statuses.planeStatus.operator.approved",
    defaultMessage: "Принят",
  },
})

export const usePlaneStatusName = (status: PlaneStatus, isAdmin: boolean = true) => {
  const messages = isAdmin ? {
    [PlaneStatus.UPLOAD_DOCUMENTS]: PlaneStatusNameMessages.uploadDocuments,
    [PlaneStatus.PENDING_APPROVAL]: PlaneStatusNameMessages.pendingApproval,
    [PlaneStatus.APPROVED]: PlaneStatusNameMessages.approved,
  } : {
    [PlaneStatus.UPLOAD_DOCUMENTS]: PlaneStatusNameMessagesForOperator.declined,
    [PlaneStatus.PENDING_APPROVAL]: PlaneStatusNameMessagesForOperator.pendingReview,
    [PlaneStatus.APPROVED]: PlaneStatusNameMessagesForOperator.approved,
  };
  
  return useEnumIntl(status, messages);
}

